export default {
	methods: {
		displayDate: (stringDate: string, defaultPlaceholder = '') => {
			if (!stringDate) {
				return defaultPlaceholder;
			}
			return new Date(Date.parse(stringDate)).toLocaleString();
		}
	}
};
